// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"78":"c9982094","285":"1f6c1f13","338":"b5e785ea","473":"8238ec84","522":"ff052c4f","541":"83596dbc","576":"3109a2a6","753":"c4aa15b1","775":"bc6aa2bd","779":"f83f89db","786":"22b85159","823":"844f0c80","989":"64b23c3e","990":"95e1b7d7"}[chunkId] + ".js";
};